var map = {
	"./Challenges.gif": 28,
	"./Combat.gif": 29,
	"./Dialogue.gif": 30,
	"./steam_launch1.png": 31,
	"./steam_launch2.png": 32,
	"./steam_launch3.png": 33,
	"./steam_launch4.png": 34,
	"./steam_launch5.png": 35,
	"./steam_launch6.png": 36,
	"./steam_launch7.png": 37,
	"./steam_launch8.png": 38
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots ^\.\/.*$
// module id = 27
// module chunks = 0